import { apiClient } from '@/shared/api/client'

export async function createPurchase(payload) {
  const response = await apiClient.post('/admin/purchase', payload)

  return response.data
}

export async function getPurchasePersons(params = {}) {
  const response = await apiClient.get('/admin/purchase', { params })
  return response.data
}

export async function updatePurchase(id, payload) {
  const response = await apiClient.put(`/admin/purchase/${id}`, payload)
  return response.data
}

export async function deletePurchase(id) {
  const response = await apiClient.delete(`/admin/purchase/${id}`)
  return response.data
}
